export enum ActionTypes {
  LOAD_VEHICLE_ROUTES_REQUEST = 'LOAD_VEHICLE_ROUTES_REQUEST',
  LOAD_VEHICLE_ROUTES_SUCCEEDED = 'LOAD_VEHICLE_ROUTES_SUCCEEDED',
  LOAD_VEHICLE_ROUTES_FAILED = 'LOAD_VEHICLE_ROUTES_FAILED',
}

export default ActionTypes;
